<app-base-auth-form [message]="'Auth.ResetPasswordMessage' | i18next" [action]="'Auth.SendCode' | i18next"
    slot="main-content" [isBusy]="isBusy" [errorMessage]="errorMessage" (performAction)="resetPassword()">

    <dx-text-box [label]="'Auth.Email' | i18next" labelMode="floating" valueChangeEvent="keyup"
        class="item large-top-space" [(value)]="email" (valueChange)="resetError()" (onEnterKey)="resetPassword()">
    </dx-text-box>

</app-base-auth-form>